import React, { useEffect, useState } from "react";
import useStyles from "./claimTokenStyles";
import Button from "@material-ui/core/Button";
import MContentIcon from "../../assets/images/icon.png";
import { useWeb3React } from "@web3-react/core";
import {
  TOKEN_ERC20,
  TOKEN_BEP20,
  BRIDGE_ERC20,
  BRIDGE_BEP20,
  BRIDGE_BEP20_ABI,
  BRIDGE_ERC20_ABI,
  TOKEN_BEP20_ABI,
  TOKEN_ERC20_ABI,
  backendURL,
  supportedChains,
} from "../../contract/constant";
import Web3 from "web3";
import millify from "millify";
import { CircularProgress } from "@material-ui/core";
import TransactionInProgress from "../../components/Modals/TransactionProcessing/TransactionInProgress";
import TransactionError from "../../components/Modals/TransactionProcessing/TransactionError";
import TransactionSuccessfull from "../../components/Modals/TransactionProcessing/TransactionSuccessfull";
import SwitchNetworkModal from "../../components/Modals/SwitchNetworkModal/SwitchNetworkModal";
import BigNumber from "bignumber.js";

function ClaimToken({claims, setClaims, getClaimableAssets, isClaimLoading, setIsClaimLoading,filterArray, setFilterArray, setTriggerTransaction, triggerTransaction}) {
  const { account, active, chainId, library } = useWeb3React();
  const classes = useStyles();
  // const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState("");
  const [transactionInProgress, setTransactionInProgress] = useState(false);
  const [taxPercentage, setTaxPercentage] = useState(0);
  const [isChainCorrect, setIsChainCorrect] = useState(false);
  const [transactionCompleted, setTransationCompleted] = useState(false);
  const [pendingTransaction, setPendingTransaction] = useState(false);
  const [transactionError, setTransactionError] = useState(false);
  const [transactionHash, setTransactionHash] = useState("");
  const [changeChainIdTo, setChangeChainIdTo] = useState(chainId);
  const [isLoading, setIsLoading] = useState(false)

  useEffect(async () => {
  // setTaxPercentage(0);
  if (account) {
    await setIsLoading(true);
    await getClaimableAssets(account).then(async ()=>{
      setTaxPercentage(await calculateTaxFee())
      setIsLoading(false);
    });
  }
  }, [account, active, chainId]);

  const calculateTaxFee = async () =>{
    const web3 = new Web3(new Web3.providers.HttpProvider("https://speedy-nodes-nyc.moralis.io/0676906f814449c55f778a3a/bsc/mainnet"))
    const contract = new web3.eth.Contract(TOKEN_BEP20_ABI, TOKEN_BEP20);
    
              let taxFee = await contract.methods._taxFee().call()
              let liquidityFee = await contract.methods._liquidityFee().call();
              let contentFee = await contract.methods._contentFee().call();
              return parseFloat(taxFee) + parseFloat(liquidityFee) + parseFloat(contentFee);
              
            }
  // const getClaimableAssetsLocal = async () => {
  //   setIsLoading(true);
  //   fetch(`${backendURL}getClaims/${account}`)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data);
  //       setClaims(data.reverse());
  //       setIsLoading(false);
  //     }).catch(e=>{
  //       console.log(e)
  //     });
  // };
 
  const handleFilterArray = async (claim) =>{
    setFilterArray([...filterArray,claim._id]);
  }
  let i = 0;
  const handleClaim = async (claim) => {
    // setValue(claim.fromChain==4 ||claim.fromChain== 1?claim.amount - claim.amount*0.1:claim.amount)
    setValue(claim.amount<1?claim.fromChain==4 ||claim.fromChain== 1?taxPercentage?parseFloat((claim.amount*((100 - taxPercentage)/100))).toFixed(4):"":claim.amount:claim.fromChain==4 ||claim.fromChain== 1?(taxPercentage?(claim.amount*((100-taxPercentage)/100)):""):claim.amount)
    if (chainId === claim.toChain) {
      setTransactionInProgress(true);
      const web3 = new Web3(library?.currentProvider);
      const contract = new web3.eth.Contract(
        chainId === supportedChains[0] ? BRIDGE_ERC20_ABI : BRIDGE_BEP20_ABI,
        chainId === supportedChains[0] ? BRIDGE_ERC20 : BRIDGE_BEP20
      );
      contract.methods
        .withdrawTokens(claim.migrationID, claim.transactionID, claim.signature)
        .send({ from: account })
        .on("transactionHash", async (hash) => {
          // await handleFilterArray(claim);
          i = 1;
          setTransactionHash(hash);
        })
        .on("confirmation",async function (confirmationNumber, receipt) {
          if(receipt.status){
          if(i<10 && i>0){
            getClaimableAssets(await web3.eth.getAccounts());
          }
          else{
            i = 0;
          }
          
          if (confirmationNumber === 0) {     
            if (chainId == claim.toChain) {
              await handleFilterArray(claim);
            }
            setTransactionInProgress(false);
            setTransationCompleted(true);    
            setTriggerTransaction(!triggerTransaction)        
            // tx confirmed
            // setTimeout(()=>{
              
              // },5000)
              //   console.log("confirmationNumber", confirmationNumber , filterArray, claim._id);
          }}
        })
        .on("error", async function (err) {
          await setTransactionInProgress(false);
          await setTransationCompleted(false);
          await setTransactionError(true)
          setTriggerTransaction(!triggerTransaction)
        });
    } else {
      setChangeChainIdTo(claim.toChain);
      setIsChainCorrect(true);
    }
  };

  const claimCard = (claim, i) => {
    return (
      <div className={`${classes.claimCardContainer} ${i+1 != claims.length && classes.marginBottom}`}  key={claim._id}>
          <div style={{ marginLeft: "auto", marginRight: "auto" }}>
            {claim.fromChain === 1 || claim.fromChain === 4 ? (
              <p className={classes.network}>ERC20 to BEP20</p>
            ) : (
              <p className={classes.network}> BEP20 to ERC20</p>
            )}
          </div>
          {/* <br /> */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div className={classes.iconBox}>
              <img
                src={MContentIcon}
                height="35px"
                width="35px"
                alt="MContentIcon"
              />
              <p className={classes.mContentText}>
                <b>MCONTENT</b>
              </p>
            </div>
            <div className={classes.amountBox}>
              <div>
                <p className={classes.amountText}>Amount</p>
              </div>
              <div>
                <p className={classes.amountNo}>
                  {(!isLoading && taxPercentage)&&(<b>{claim.amount<1?claim.fromChain==4 ||claim.fromChain== 1?taxPercentage?parseFloat((claim.amount*((100 - taxPercentage)/100))).toFixed(4):"":claim.amount:millify(claim.fromChain==4 ||claim.fromChain== 1?(taxPercentage?(claim.amount*((100-taxPercentage)/100)):""):claim.amount, {
  precision: 3,
  lowercase: false
})}</b>)}
                </p>
              </div>
            </div>
          </div>
          <br />
          <div>
            <Button
              variant="contained"
              fullWidth
              className={classes.claimBtn}
              disabled={filterArray.includes(claim._id)}
              onClick={async () => {
                await handleClaim(claim);}}
            >
              {filterArray.includes(claim._id)?"CLAIMED":"CLAIM"}
            </Button>
          </div>
        </div>
    );
  };

  return (
    <div style={{overflowY:"auto", maxHeight:"55vh", minHeight:"40vh", marginTop:"20px"}}>
      {(
        <div style={{textAlign:"center"}}>{isLoading?<CircularProgress style={{ color: "#FFDF00", fontWeight: "900", marginTop:"25%", }} size={60} />:claims && claims.length ? (
          claims.map((claim, i) => {
            return claimCard(claim, i);
          })
        ) :     
        <h3 style={{marginTop:"25%",}}>Deposit token first to execute claim</h3>
        // <>{claimCard({id:1, to:"123123", from:"123123",fromChain:1,toChain:56, amount:"10000" }, 2)}</>
        }
        </div>
      )}
      <TransactionInProgress transactionInProgress={transactionInProgress} setTransactionInProgress={setTransactionInProgress} chainId={chainId} value={value} height={"250"} claimItem={true}/>
    <TransactionError transactionError={transactionError} setTransactionError={setTransactionError}/>
  <TransactionSuccessfull transactionCompleted={transactionCompleted} setTransationCompleted={setTransationCompleted} setValue={setValue} setTransactionHash={setTransactionHash} claimTokensModal={true} transactionHash={transactionHash} chainId={chainId} value={value} height={"290px"} claimItem={true}/>
  <SwitchNetworkModal isChainCorrect={isChainCorrect} setIsChainCorrect={setIsChainCorrect} claimTokensModal={true} chainId={changeChainIdTo}/>
    </div>
  );
}

export default ClaimToken;
